<template>
<div >






<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="mt-4" v-if="!loading" style="min-height:450px">


<div class="grid">
<div class="col-6">

<ClickEditSelect :title="$store.state.languages.lang_phrases.denetci" :value="selected_auditor" :options="auditors" valkey="type" @dataChanged="auditorSelected" emptymessage="Bu görüşmede kullanılan soru listesine henüz denetçi atanmamış" />


<template v-if="selected_date">
<div class="grid">

<div class="col-3 md:col-2">
<p class="click_edit_value_title">{{$store.state.languages.lang_phrases.oturum_tarihi}}:</p>
</div>

<div class="col-9 md:col-10">
<p class="click_edit_value animate_class">
{{ $filters.momentFormat( selected_date," Do-MM-YYYY dddd")}}
</p>
</div>

</div>

<div class="grid pl-2">
<div class="field col-6 ">
<label for="starttime">Başlama Saati</label>
<Calendar inputId="starttime"  v-model="selected_start_time" :timeOnly="true" :stepMinute="15" :touchUI="false" :modelValue="selected_start_time" class="p-inputtext-sm w-full" @date-select="startTimeUpdated"/>
</div>

<div class="field col-6 ">
<label for="endtime">Bitiş Saati</label>
<Calendar inputId="endtime"  v-model="selected_end_time" :timeOnly="true" :stepMinute="15" :touchUI="false" :modelValue="selected_end_time" class="p-inputtext-sm w-full" />
</div>
</div>

<ClickEditInputText  :title="$store.state.languages.lang_phrases.video_konferans_linki" :value="selected_video_link" valkey="videocall_link" @dataChanged="videoLinkEntered"></ClickEditInputText>

<ClickEditInputTextArea  :title="$store.state.languages.lang_phrases.denetciye_not" :value="note_to_auditor" valkey="note_to_auditor" @dataChanged="auditorNoteEntered"></ClickEditInputTextArea>



<!--
<template v-if="supplierpreaudits.length">
 <div class="grid">
  <div class="col-12">
  <h4 class="text-primary">Yapılan değişiklikleri seçili ön planlamalara da uygula</h4>
</div>
<div class="col-12">
<DataTable 
:value="supplierpreaudits" 
dataKey="id" 
:rowHover="true"
v-model:selection="selectedsupplierpreaudits" 
>
<Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
<Column   :header="$store.state.languages.lang_phrases.akis" sortable field="flow_name">
<template #body="slotProps">
<router-link class="text-primary p-link no-underline" :to="{ name: 'Preaudit' , params: { id: slotProps.data.id }}">{{ slotProps.data.flowsupplier.flow.name}}</router-link>
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.durum" 
field="status">
<template #body="slotProps">
  <template v-if="slotProps.data.status=='awaiting_schedule'">
  <Tag 
  class="ml-2  mb-2 custom-chip" 
  :value="$store.state.languages.lang_phrases.planlama_bekliyor" 
  style="background-color:#352f8d"
  />  
  </template>

  <template v-if="slotProps.data.status=='scheduled'">
  <Tag 
  class="ml-2  mb-2 custom-chip" 
  :value="$store.state.languages.lang_phrases.planlandi" 
  style="background-color:#4dc247"
  />  
  </template>

  <template v-if="slotProps.data.status=='finished'">
  <Tag 
  class="ml-2  mb-2 custom-chip" 
  :value="$store.state.languages.lang_phrases.tamamlandi0" 
  style="background-color:#4dc247"
  />  
  </template>

  <template v-if="slotProps.data.status=='rescheduled'">
  <Tag 
  class="ml-2  mb-2 custom-chip" 
  :value="$store.state.languages.lang_phrases.tekrar_planlandi" 
  style="background-color:#ff6600"
  />  
  </template>

  <template v-if="slotProps.data.status=='on_planning'">
  <Tag 
  class="ml-2  mb-2 custom-chip" 
  :value="$store.state.languages.lang_phrases.planlamada" 
  style="background-color:#3b82f6"
  />  
  </template>

  <template v-if="slotProps.data.status=='under_review'">
  <Tag 
  class="ml-2  mb-2 custom-chip" 
  :value="$store.state.languages.lang_phrases.degerlendirmede" 
  style="background-color:#ff6600"
  />  
  </template>


</template>
</Column>


<Column   :header="$store.state.languages.lang_phrases.denetci" sortable field="auditor_name">
<template #body="slotProps">
  <template v-if="slotProps.data.auditor">
    {{slotProps.data.auditor.user.name}}
  </template>
</template>
</Column>

<Column 
:header="$store.state.languages.lang_phrases.oturum_tarihi" 
field="scheduled_at" 
style="min-width: 8rem">
<template #body="slotProps">
  <template v-if="slotProps.data.scheduled_at">
    {{ $filters.momentFormat( slotProps.data.scheduled_at," Do MM YYYY HH:mm")}}
  </template>
    
</template>
</Column>

<Column   :header="$store.state.languages.lang_phrases.proje_periyodu" sortable field="auditor_name">
<template #body="slotProps">
  <template v-if="slotProps.data.projectperiod">
    {{slotProps.data.projectperiod.name}}
  </template>
</template>
</Column>



</DataTable>
</div>
 


 </div>
</template>
-->








<div class="flex justify-content-end flex-wrap mt-3" v-if="selected_auditor && selected_date && selected_start_time" >
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" @click="submit"></Button>
</div>



</template>



</div>






<div class="col-6" v-if="selected_auditor">
<FullCalendar  :options="options" />
</div>



</div>




</div>

<ScheduleDetailsModal></ScheduleDetailsModal>

</div>
</template>

<script>
import '@fullcalendar/core';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import trLocale from '@fullcalendar/core/locales/tr';
import enLocale from '@fullcalendar/core/locales/en-gb';
import moment from "moment"
export default {

  name: 'FlowConditions',

  data () {
    return {
    	options: {
        plugins:[dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialDate : null,
        contentHeight:600,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        editable: false,
        selectable:true, 
        selectMirror: true, 
        dayMaxEvents: true,
        locale:trLocale,
        dateClick: this.handleDateClick,
        eventClick: this.hadleEventClick,
        events: [],
      },
      supplierpreaudits:[],
    	loading:true,
      item:null,
      auditors:[],
      selected_auditor:null,
      selected_date:null,
      selected_start_time:null,
      selected_end_time:null,
      selected_video_link:null,
      note_to_auditor:null,
      ready_to_submit:false,
      selectedsupplierpreaudits:[],
    }
  },
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  computed:{
    userlang()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:{
    userlang(newval)
    {
      if(newval==3)
      {
        this.options.locale = trLocale
      }
      if(newval==15)
      {
        this.options.locale = enLocale
      }
    }
  },
  mounted()
  {    
    this.getData()
  },
  methods:{
    createEventObj(date,hours)
    {
      console.log(this.item)
      let events = this.sanitizeArray(this.options.events)
      events = events.filter((item)=>{return item.id !== this.item.id})
      //let duration = this.$store.state.preaudits.preaudit.flowsupplier.flow.preauditsettings.session_duration
      let end_moment = moment(date+" "+hours,"Do-MM-YYYY HH:mm").add(60,"minutes")
      let end_date = end_moment.format("Do-MM-YYYY")
      let end_hours = end_moment.format("HH:mm")
      console.log("end")
      console.log(date+" "+hours)
      console.log(end_moment)
      console.log(end_date+" "+end_hours)
      this.options.events = events
      let event =  {
        id: this.item.id,
        title: this.item.supplier.name,
        start: date+" "+hours,
        end:end_date+" "+end_hours,
      }
      this.options.events.push(event)
    },
    async auditorSelected(data)
    {
      console.log(data)
      this.options.events = []
      let selected_auditor = this.auditors.find((item)=>{return item.id == data.value})
      this.selected_auditor = selected_auditor
      console.log(selected_auditor)
      await this.getAuditorpreauditSchedule()
    },
    videoLinkEntered(data)
    {
      this.selected_video_link = data.value
      this.ready_to_submit = true
    },
    auditorNoteEntered(data)
    {
      this.note_to_auditor = data.value      
    },
    hadleEventClick(data)
    {
      console.log(data)  
      this.$store.dispatch('preaudits/setSelectedEvent',data.event._def.publicId) 
      this.$store.dispatch('preaudits/setShowDetailModal',true) 
    },
    handleDateClick(data)
    {
      //let duration = this.$store.state.preaudits.preaudit.flowsupplier.flow.preauditsettings.session_duration
      this.selected_date = data.date
      let start = moment(data.dateStr+" 08:00","Do-MM-YYYY HH:mm")
      let end = moment(data.dateStr+" 08:00","Do-MM-YYYY HH:mm").add(60,"minutes")
      this.createEventObj(data.dateStr,"08:00")
      console.log("datte") 
      console.log(start)   
      console.log(end)      
      this.selected_start_time = start.toDate()
      this.selected_end_time = end.toDate()


    },
    submit()
    {
      let selectedsupplierpreaudits = this.selectedsupplierpreaudits.map(item=>item.id)
      //return false
      let formdata = new FormData()
      formdata.append("auditor_id",this.selected_auditor.auditor.id)
      formdata.append("date",moment(this.selected_date).format("YYYY-MM-DD"))
      formdata.append("start",moment(this.selected_start_time).format("HH:mm"))
      formdata.append("videocall_link",this.selected_video_link)
      formdata.append("note_to_auditor",this.note_to_auditor)
      formdata.append("selectedsupplierpreaudits",JSON.stringify(selectedsupplierpreaudits))
      this.generalSubmission(formdata,"preaudit/set_preaudit_data/"+this.$route.params.id,this.afterSubmit)
    },
    async afterSubmit(response)
    {
      console.log(response.data)
      let item = await this.generalApiGetWithoutLoader("preaudit/"+this.$route.params.id)
      item = await this.parsepreauditData(item)
      this.item = await item
      this.$store.dispatch('preaudits/setPreaudit',this.item) 
      await this.adjustOtherSchedules(item)
    },
    async adjustOtherSchedules(item)
    {
      let supplierpreaudits = await this.generalApiGetWithoutLoader("preaudit/supplier_preaudits/"+item.supplier_id)
       this.supplierpreaudits = await supplierpreaudits.filter(element=>element.id !==item.id)
       this.selectedsupplierpreaudits = []
    },
    startTimeUpdated(event)
    {
      //let duration = this.$store.state.preaudits.preaudit.flowsupplier.flow.preauditsettings.session_duration
      console.log(event)
      console.log(this.selected_start_time)
      let end = moment(this.selected_start_time,"Do-MM-YYYY HH:mm").add(60,"minutes")
      this.selected_end_time = end.toDate()
    },
    async parsepreauditData(item)
    {
      //let duration = this.$store.state.preaudits.preaudit.flowsupplier.flow.preauditsettings.session_duration
      
      
      if(item.auditor)
      {        
        let selected_auditor = this.auditors.find((element)=>{return element.auditor_id == item.auditor.id})
        this.selected_auditor = selected_auditor
      }
      if(item.schedule_date)
      {
        this.selected_date = item.schedule_date
      }

      if(item.schedule_time)
      {
        let start = moment(item.schedule_date+" "+item.schedule_time,"Do-MM-YYYY HH:mm")
        this.selected_start_time = start.toDate()
        //this.selected_end_time = item.schedule_time.add(duration,"hours")
        let end = moment(item.schedule_date+" "+item.schedule_time,"Do-MM-YYYY HH:mm").add(60,"minutes")        
        console.log(end)
        this.selected_end_time = end.toDate()
      }
      if(item.videocall_link)
      {
        this.selected_video_link = item.videocall_link
      }
      if(item.note_to_auditor)
      {
        this.note_to_auditor = item.note_to_auditor
      }
      if(item.auditor && item.schedule_date && item.schedule_time)
      {
        this.item = item
        this.createEventObj(item.schedule_date,item.schedule_time)
        this.options.initialDate = item.scheduled_at
      }
      

      return item
    },
    async getAuditorpreauditSchedule()
    {
      
      let events
      events = await this.generalApiGetWithoutLoader("verification/auditor_all_schedule/"+this.selected_auditor.auditor_id)
      
      console.log(events)
      for(let event of events)
      {
        
        if(event.flowsupplier)
        {
          let flowsupplier = event.flowsupplier
          if(event.preaudit)
          {
            let preaudit = event.preaudit
            if(preaudit.id !==this.item.id)
            {
              let new_event =  {
                id: preaudit.id,
                title: flowsupplier.supplier.name,
                start: preaudit.schedule_date+" "+preaudit.schedule_time,
                color:"#a82400"
              }
              this.options.events.push(new_event)
            }
          }

          if(event.verification)
          {
            console.log("this. verification")
            let verification = event.verification
            
              let new_event =  {
                id: verification.id,
                title: flowsupplier.supplier.name,
                start: verification.schedule_date+" "+verification.schedule_time,
                color:"#a82400"
              }
              this.options.events.push(new_event)            
          }

          if(event.audit)
          {
            let audit = event.audit
            
              let new_event =  {
                id: audit.id,
                title: flowsupplier.supplier.name,
                start: audit.schedule_date+" "+audit.schedule_time,
                color:"#a82400"
              }
              this.options.events.push(new_event)            
          }

          
        }
      }

    },
    
  	async getData()
    {
       let item = await this.generalApiGetWithoutLoader("preaudit/"+this.$route.params.id)
       let auditors = await this.generalApiGetWithoutLoader("verification/questionlist_auditors/"+item.flowsupplier.flow.questionlist_id)
       await this.adjustOtherSchedules(item)
       await console.log("auditors")
       await console.log(auditors)
       for(let item of auditors)
       {
        item.name = item.auditor.user.name + " - "+item.auditor_points+" "+this.$store.state.languages.lang_phrases.puan        
       }
       this.auditors = await auditors

       
       await console.log(item)
       item = await this.parsepreauditData(item)
       this.item = await item
       if(this.item.auditor)
       {
          await this.getAuditorpreauditSchedule()
       }
       

       this.$store.dispatch('preaudits/setPreaudit',this.item) 
       this.loading = await false

    },   
  }
};
</script>

<style lang="css" scoped>
</style>